export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodie',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirt',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jacket',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';